import { type ChallengeSummary } from '@/lib/types';
import PortfolioItemCardThumbnailContext from '../../portfolio-item/PortfolioItemCardThumbnail/PortfolioItemCardThumbnailContext';
import PortfolioItemCardThumbnail from '../../portfolio-item/PortfolioItemCardThumbnail';
import { useContext } from 'react';
import NewlySharedContext from '../../NewlySharedChallenges/NewlySharedContext';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';
import { type DraftFunction } from 'use-immer';

export type ChallengeSummaryWithThumbnail = ChallengeSummary & {
  thumbnail: NonNullable<ChallengeSummary['thumbnail']>;
};

type ChallengeThumbnailProps = {
  challenge: ChallengeSummaryWithThumbnail;
};

const ChallengeThumbnail = ({ challenge }: ChallengeThumbnailProps) => {
  const [isNewlyShared, , setNewlySharedChallenges] =
    useContext(NewlySharedContext);
  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);

  const setChallengeSummary = (
    stateUpdateFunction: DraftFunction<ChallengeSummary>,
  ): void => {
    if (isNewlyShared) {
      setNewlySharedChallenges(newlySharedChallenges => {
        stateUpdateFunction(newlySharedChallenges[challenge.id]);
      });

      return;
    }

    setChallengePortfolio(challengePortfolio => {
      stateUpdateFunction(challengePortfolio.challenges[challenge.id]);
    });
  };

  const challengeApiEndpoint = `challenge-portfolio/challenges/${challenge.id}`;

  return (
    <PortfolioItemCardThumbnailContext.Provider
      value={{
        portfolioItemSummary: challenge,
        setPortfolioItemSummary: setChallengeSummary,
        portfolioItemApiEndpoint: challengeApiEndpoint,
      }}
    >
      <PortfolioItemCardThumbnail />
    </PortfolioItemCardThumbnailContext.Provider>
  );
};

export default ChallengeThumbnail;
